import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initWebVitals } from '@/lib/performance';
import './styles/globals.css';

async function enableMocking() {
  if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MOCKS !== 'false') {
    const { worker } = await import('./test/mocks/browser');
    return worker.start({ onUnhandledRequest: 'warn' });
  }
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

void enableMocking().then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );

  void initWebVitals();
});
